import React, { Component } from 'react'

import styles from './style.css'

export default class AspectRatio extends Component {
    render() {
        return (
            <div className={styles.scope}>
                <div className={`${styles.content} ${styles[`ratio${this.props.ratio || '1x1'}`]}`} />
                <div className={styles.container} style={this.props.style || {}}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/atoms-v2/AspectRatio/index.js